export const EPermCode = {
  'L-ML': 'L-ML',
  'L-THS': 'L-THS',
  'L-LA': 'L-LA',
  'L-LAdj': 'L-LAdj',
  'L-IL': 'L-IL'
}

export const MAIN_MODULE_CODES = {
  E_LEAVE: 'eleave',
  E_TIME: 'etime',
  E_PAY: 'epay',
  E_CERT: 'ecert'
}

export const TOKEN_PERMISSION_CODES = {
  LEAVE_REQ: 'LEAVE_REQ',
  LEAVE_DELEGATE: 'LEAVE_DELEGATE',
  LEAVE_APP: 'LEAVE_APP',
  LEAVE_REP: 'LEAVE_REP',
  TIME_REQ: 'TIME_REQ',
  TIME_APP: 'TIME_APP',
  TIME_REP: 'TIME_REP',
  TIME_DELEGATE: 'TIME_DELEGATE',
  EPAY: 'EPAY',
  ECERT: 'ECERT'
}

export const ADMIN_SETTING_PERMISSION_CODES = {
  LOGIN: 'ESS-LOGIN-SETTING',
  EPAYSLIP: 'ESS-EPAYSLIP-SETTING',
  ECERTIFICATE: 'ESS-ECERTIFICATE-SETTING',
  ELEAVE: 'ESS-ELEAVE-SETTING',
  ETIME: 'ESS-ETIME-SETTING',
  HOME: 'ESS-HOME-SETTING',
  PAY_PERIOD: 'ESS-PAY-PERIOD-SETTING',
  WORKFLOW: 'ESS-WORKFLOW-SETTING',
  AUDIT_LOG: 'ESS-AUDIT-LOG-SETTING',
  PSEUDO_PERM: 'ESS-PSEUDO-PERM-SETTING'
}

export const ELEAVE_TOKEN_PERMISSION_CODES = [
  TOKEN_PERMISSION_CODES.LEAVE_REQ,
  TOKEN_PERMISSION_CODES.LEAVE_APP,
  TOKEN_PERMISSION_CODES.LEAVE_REP
]

export const ETIME_TOKEN_PERMISSION_CODES = [
  TOKEN_PERMISSION_CODES.TIME_REQ,
  TOKEN_PERMISSION_CODES.TIME_APP,
  TOKEN_PERMISSION_CODES.TIME_REP
]
